import { useEffect, useState } from 'react';
import { useGetWidgetConfig } from 'mf_shared/widget';

export function useAreWidgetsConfigured() {
  const [areWidgetsConfigured, setAreWidgetsConfigured] = useState(false);

  const { data } = useGetWidgetConfig();

  useEffect(() => {
    const selectedWidgets = data?.widgets.filter(
      (item: any) => item.isSelected
    );
    const hasWidgets = selectedWidgets ? selectedWidgets.length > 0 : false;

    setAreWidgetsConfigured(hasWidgets);
  }, [data?.widgets]);

  return areWidgetsConfigured;
}
